import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../axios/endpoints";
import axios from "../../../axios/defaultAxios";
import { errorMessage } from "@/store/actions/messages.actions";

export const requestResources = createAsyncThunk(
  `${slices.resources}/requestResources`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(endpoints.resources);
      const {
        data: { data: data },
      } = response;
      return data;
    } catch (error) {
      console.log(error);
      dispatch(errorMessage("Error while "));
      return rejectWithValue({ error });
    }
  }
);

export const requestResourcesStatus = {
  [requestResources.fulfilled]: (state, action) => {
    state.resources = action.payload;
    state.loading = false;
  },
  [requestResources.pending]: (state, action) => {
    state.loading = true;
  },
  [requestResources.rejected]: (state, action) => {
    state.error = action.payload.error;
    state.loading = false;
  },
};
